export class RevenueValues {
  label: string;
  revenue_pre_returns: number;
  percentage_of_revenue: number;
  packages: number;
  revenue_post_returns: number;

  constructor(obj?: Partial<RevenueValues>) {
    this.label = obj?.label ?? '';
    this.revenue_pre_returns = obj?.revenue_pre_returns ?? 0;
    this.percentage_of_revenue = obj?.percentage_of_revenue ?? 0;
    this.packages = obj?.packages ?? 0;
    this.revenue_post_returns = obj?.revenue_post_returns ?? 0;
  }
}

export class RevenueModel {
  rx: RevenueValues | null = null;
  of_which_hp: RevenueValues | null = null;
  non_rx: RevenueValues | null = null;
  sums: RevenueValues | null = null;
  visible = false;

  constructor(obj?: Partial<RevenueModel>) {
    if (!obj) return;

    if (obj.rx) { obj.rx.label = 'Rezeptpflichtig'; this.rx = new RevenueValues(obj.rx); }
    if (obj.of_which_hp) { obj.of_which_hp.label = 'davon Hochpreis'; this.of_which_hp = new RevenueValues(obj.of_which_hp); }
    if (obj.non_rx) { obj.non_rx.label = 'Non-RX'; this.non_rx = new RevenueValues(obj.non_rx); }
    if (obj.sums) { obj.sums.label = 'Summe'; this.sums = new RevenueValues(obj.sums); }

    this.visible = obj.visible ?? false;
  }
}
